import React from "react";
import type { TIconKey } from "@/types";
import { navIconComponentMap } from "@/components/navigation/navIcon/navIconClassMap";

type TNavIconVariant = "mobile" | "desktop";

interface NavIconProps {
  iconKey: TIconKey;
  variant: TNavIconVariant;
  className?: string;
}

const NavIcon: React.FC<NavIconProps> = ({
  iconKey,
  variant,
  className = "",
}) => {
  const IconComponent = navIconComponentMap[iconKey];
  const variantClass = variant === "mobile" ? "fs-18 lh-1" : "fs-18 lh-1";

  return (
    <IconComponent
      size="1em"
      className={`${variantClass} ${className ? className : ""}`}
    />
  );
};

export default NavIcon;
